import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { projectsApi } from "@/lib/api";
import CalcBar from "@/components/CalcBar";
import WoodenHouseEditor from "@/pages/WoodenHouseEditor";
import FrameHouseEditor from "@/pages/FrameHouseEditor";
import StructuralEditor from "@/pages/StructuralEditor";

export default function ProjectEditor() {
  const { id } = useParams();
  const nav = useNavigate();
  const [project, setProject] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        setProject(await projectsApi.get(id));
      } catch (e) {
        toast.error("Proje yüklenemedi");
        nav("/");
      }
    })();
  }, [id, nav]);

  if (!project) return <div className="p-8 text-slate-400" data-testid="project-loading">Yükleniyor…</div>;

  let editor;
  if (project.category === "wooden_house") {
    editor = ["karkas", "yigma", "clt"].includes(project.system_type)
      ? <FrameHouseEditor id={id} initialProject={project} />
      : <WoodenHouseEditor id={id} initialProject={project} />;
  } else {
    editor = <StructuralEditor id={id} initialProject={project} />;
  }
  return (
    <div>
      <CalcBar projectId={id} />
      {editor}
    </div>
  );
}
